module.exports = __webpack_public_path__ + "static/img/software_icon2.6ba200c6.png";